module.exports = __webpack_public_path__ + "static/media/fa-solid-900.5ee32f5c.ttf";